import AppParallax from '../app-parallax'
import MixinResize from '../mixin-resize'

export default
{
    mixins: [
        MixinResize
    ],

    components: {
        AppParallax
    },

    methods:
    {
        onImgLoaded()
        {
            this.$nextTick(() => this.resize.dispatch())
        },

        onResized()
        {
            // Hide warning
        }
    }
}
